import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconGenderMale: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="gender-male"><circle cx="9" cy="15" r="5.75" stroke="currentColor" strokeWidth="1.5"/><path d="M14.75 3.75H20.25V9.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M13.25 10.75L19.5 4.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconGenderMale;
